import { render, staticRenderFns } from "./BecomeMember.vue?vue&type=template&id=2e369e54&scoped=true"
import script from "./BecomeMember.vue?vue&type=script&lang=js"
export * from "./BecomeMember.vue?vue&type=script&lang=js"
import style0 from "./BecomeMember.vue?vue&type=style&index=0&id=2e369e54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e369e54",
  null
  
)

export default component.exports